import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContactsFormStep2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 604 736",
	width: "100%",
	height: "100%",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "#0669FD",
			strokeOpacity: .3,
			d: "M604.335 95.003C334.083 95.003 115 222.924 115 380.722s219.083 285.719 489.335 285.719"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#0669FD",
			strokeOpacity: .3,
			d: "M604.334 95.004c-256.569 0-464.559 119.365-464.559 266.61s207.99 266.61 464.559 266.61"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#0669FD",
			strokeOpacity: .3,
			d: "M604.333 95c-242.885 0-439.782 110.403-439.782 246.592 0 136.189 196.897 246.592 439.782 246.592"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#0669FD",
			strokeOpacity: .3,
			d: "M604.334 95c-232.622 0-421.199 101.033-421.199 225.664 0 124.63 188.577 225.663 421.199 225.663"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#0669FD",
			strokeOpacity: .3,
			d: "M604.338 95c-222.359 0-402.617 92.478-402.617 206.555 0 114.078 180.258 206.555 402.617 206.555"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#0669FD",
			strokeOpacity: .3,
			d: "M604.334 95.001c-215.517 0-390.229 83.923-390.229 187.447 0 103.523 174.712 187.446 390.229 187.446"
		})
	]
});
export default SvgContactsFormStep2;
